export const getEnvVar = (name: string): string => {
  const value = process.env[`REACT_APP_${name}`]

  if (value) {
    return value
  } else {
    throw new Error(`Missing env var '${name}'`)
  }
}
